<template>
  <div class="text-center">
    <div class="text-h6">404 Not Found</div>
    <v-btn color="primary" :to="{ name: 'Home' }" class="mt-4">
      Back to home
    </v-btn>
  </div>
</template>
